import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
// import { isInQuantumWindow } from 'utils/time';
import typography from 'styles/typography';
import Countdown from '../Countdown';

const QuantumCountdown = () => {
  // const inQuantumWindow = isInQuantumWindow();
  const inQuantumWindow = true;

  return (
    <Box sx={{ ...typography.buttonLarge, paddingBottom: '5px' }}>
      <Countdown
        isInQuantumWindow={inQuantumWindow}
        endMessage={(
          <Typography variant="buttonLarge" className="monospace">
            ✅
            {' '}
            Device is online now
          </Typography>
        )}
        progressMessage={(
          <Typography variant="buttonLarge" className="monospace">🕒 Device comes online in:</Typography>
        )}
      />
    </Box>
  );
};

export default QuantumCountdown;
